import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Grid, MenuItem, Select, Typography, FormControl, InputLabel, TextField, Autocomplete, Box, Modal, Button, InputAdornment } from "@mui/material";
import { useGetAllChaptersPaginationMutation, useGetMonitorChapterShareMutation, usePayChaterShareMutation } from "../../app/services/chapterServices";
import { setChapterSharePayload, setChapterShareReportDetails } from "../../app/features/chapterReportSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Component/spinner/spinner"
// Month key-value pairs
const months = [
    {
        id: 1,
        value: "January"
    },
    {
        id: 2,
        value: "February"
    },
    {
        id: 3,
        value: "March"
    },
    {
        id: 4,
        value: "April"
    }
    , {
        id: 5,
        value: "May"
    },
    {
        id: 6,
        value: "June"
    },
    {
        id: 7,
        value: "July"
    },
    {
        id: 8,
        value: "August"
    },
    {
        id: 9,
        value: "September"
    },
    {
        id: 10,
        value: "October"
    },
    {
        id: 11,
        value: "November"
    },
    {
        id: 12,
        value: 'December'
    }];

const style1 = {
    position: "absolute",
    top: "55%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 1000,
    minWidth: 300,
    height: '60%',
    bgcolor: "background.paper",
    boxShadow: 24,
    padding: 4,
    overflowY: 'scroll',
    "&::-webkit-scrollbar": {
        display: 'none'
    },
}

const MonitorChapterShare = () => {
    const [chaptermonitor] = useGetMonitorChapterShareMutation()
    const [payChapter] = usePayChaterShareMutation()
    const [getallChapter] = useGetAllChaptersPaginationMutation();
    const [Chapters, setChapters] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openForm, setOpenForm] = useState(false)
    const [loading, setLoading] = useState(true)

    const {
        control,
        watch,
        register,
        handleSubmit,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            chapterId: '',
            fromYear: '',
            fromMonth: '',
            toYear: '',
            toMonth: ''
        },
    });

    const {
        control: controlPay,
        register: registerPay,
        setError: setErrorPay,
        handleSubmit: handleSubmitPay,
        watch: watchPay,
        reset: resetPay,
        setValue: setValuePay,
        clearErrors: clearErrorPay,
        formState: { errors: errorsPay },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            chapterId: '',
            amount: '',
            paymentDate: '',
            balance: '',
            payType: '', //0 - credit,1 - debit
            description: ''
        },
    });
    const fromYear = Number(watch('fromYear'));
    const fromMonth = Number(watch('fromMonth'));
    const toYear = Number(watch('toYear'));
    const toMonth = Number(watch('toMonth'));
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (fromYear && fromMonth && toYear && toMonth) {
                const fromDate = new Date(fromYear, fromMonth - 1);
                const toDate = new Date(toYear, toMonth - 1);
                if (toYear > new Date().getFullYear()) {
                    setError('toYear', {
                        type: 'manual',
                        message: 'Future year is not allowed',
                    });
                }
                else if (fromYear > toYear) {
                    setError('toYear', {
                        type: 'manual',
                        message: 'To year must be later than or equal to From year',
                    });
                    clearErrors('toMonth')
                    return
                }
                else if (fromDate > toDate) {
                    setError('toMonth', {
                        type: 'manual',
                        message: 'Only the current or future month/year values are allowed in the To month field.',
                    });
                    clearErrors('toYear')

                } else {
                    clearErrors(['toMonth', 'toYear']);
                }
            }
        }, 300); // Debounce validation

        return () => clearTimeout(timeoutId);
    }, [fromMonth, fromYear, toMonth, toYear, clearErrors, setError]);
    const handleFormClose = () => {
        setOpenForm(false)
        resetPay({
            chapterId: '',
            amount: '',
            paymentDate: ''
        })
    }
    const handleOpenForm = () => {
        setOpenForm(true);
    }

    useEffect(() => {
        setLoading(true)
        getallChapter({
            page: 1,
            itemsPerPage: "",
            searchTerm: "",
            approve: 2
        }).then((res) => {
            setLoading(false)
            if (res?.data?.data?.chapterData) {
                setChapters(res?.data?.data?.chapterData || [])
            }
            else {
                setChapters([])
            }
        }).catch(() => setLoading(false))
    }, [setChapters, getallChapter, navigate])



    const monitorshare = (data) => {
        // Additional validation before submit
        const fromDate = new Date(data.fromYear, data.fromMonth - 1);
        const toDate = new Date(data.toYear, data.toMonth - 1);
        if (data.fromYear > data.toYear) {
            setError('toYear', {
                type: 'manual',
                message: 'To year must be later than or equal to From year',
            });
            return
        }
        else if (fromDate > toDate) {
            setError('toMonth', {
                type: 'manual',
                message: 'Only the current or future month/year values are allowed in the To month field.',
            });

            return; // Prevent form submission
        }
        else {
            clearErrors()
            setLoading(true)

            chaptermonitor(data).then((res) => {
                setLoading(false)
                if (res?.data?.data) {
                    dispatch(setChapterSharePayload(data));
                    dispatch(setChapterShareReportDetails(res?.data?.data));
                    navigate('/admin/chapterFinancialReport')
                    toast.success(res?.data?.message)
                }
                else {
                    toast.error(res?.data?.err?.message)
                }
            }).catch(() => setLoading(false))
        }
    };
    const payChapterFn = (formData) => {
        setLoading(true)
        payChapter({ ...formData, balance: formData.balance.split('₹')[1] }).then(res => {
            setLoading(false)
            if (res?.data?.data) {
                handleFormClose()
                toast.success('Payment to chapter is added successfully !!!')
            }
            else {
                toast.error(res?.data?.err?.message)
            }
        }).catch(() => setLoading(false))
    }

    return (
        <>
            <Box>
                {/* <TopHeader /> */}
                <div className="pt-5 mb-4">
                    <div className="chapter-heading">
                        <h2 className="text-center title-font text-light py-3 mt-1">Financial Report Of Chapter's Share</h2>
                    </div>
                </div>
            </Box>
            {loading ? <Spinner></Spinner> :
                <div className="p-3 p-md-5 overallpadding">
                    <div className='text-end mb-3 d-print-none'>
                        <Button onClick={() => window.history.back()} variant="contained" className='menus-color'
                        >Back</Button>
                    </div>
                    <div className='text-end mb-3 d-print-none'>
                        <Button onClick={handleOpenForm} variant="contained"
                            className="rounded-0 d-print-none"
                            color="primary"
                        >Pay Chapter</Button>
                    </div>
                    <form onSubmit={handleSubmit(monitorshare)} className="mt-3">
                        <Grid container rowSpacing={3} columnSpacing={3} className="d-flex justify-content-start">
                            <Grid item xs={12} lg={4} md={6}>
                                <Controller
                                    control={control}
                                    name="chapterId"
                                    rules={{ required: "Please select a chapter" }} // Validation rule
                                    render={({ field, fieldState }) => (
                                        <Autocomplete
                                            id="chapterId"
                                            fullWidth
                                            options={Chapters}
                                            disableCloseOnSelect={false} // Ensures dropdown closes on selection
                                            getOptionLabel={(chapter) => chapter?.title}
                                            isOptionEqualToValue={(option, value) => option._id === value._id} // Fixes deprecation of getOptionSelected
                                            onChange={(event, value) => {
                                                field.onChange(value?._id); // Store single _id instead of array
                                            }}
                                            key={Chapters.length}
                                            filterOptions={(options, { inputValue }) =>
                                                options.filter((chapter) =>
                                                    chapter?.title?.toLowerCase().includes(inputValue.toLowerCase())
                                                )
                                            }
                                            value={Chapters.find((group) => group._id === field.value) || null} // Ensure it finds the correct object
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={!!fieldState?.error}
                                                    helperText={fieldState?.error?.message}
                                                    variant="outlined"
                                                    label={
                                                        <Typography className="text-dark w-100 d-inline-block overflow-hidden text-nowrap"
                                                            style={{ textOverflow: "ellipsis" }}>
                                                            Chapter Name{" "}
                                                            <span style={{ color: "red" }}>*</span>
                                                        </Typography>
                                                    }
                                                    placeholder={watch('chapterId') ? '' : "Select Chapter Name"}
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* From Month */}
                            <Grid item xs={12} md={6} lg={4}>
                                <Controller
                                    control={control}
                                    name="fromMonth"
                                    rules={{
                                        required: "Please select a month",
                                    }} // Validation rule
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth error={!!fieldState.error}>
                                            <InputLabel id="fromMonth-label" className="text-dark">
                                                From Month <span style={{ color: "red" }}>*</span>
                                            </InputLabel>
                                            <Select
                                                {...field} // Pass field props correctly
                                                label={
                                                    <Typography className="text-dark">
                                                        From Month
                                                        <span style={{ color: "red" }}>*</span>
                                                    </Typography>
                                                } id="fromMonth"
                                                value={field.value || ""} // Ensure value is controlled
                                                onChange={(e) => field.onChange(e.target.value)} // Handle change correctly
                                            >
                                                <MenuItem value="">Select Month</MenuItem>
                                                {months.map((data) => (
                                                    <MenuItem key={data.id} value={data.id}>
                                                        {data.value}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {fieldState.error && (
                                                <Typography variant="body2" color="error">
                                                    {fieldState.error.message}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    )}
                                />
                            </Grid>

                            {/* From Year */}
                            <Grid item xs={12} md={6} lg={4}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    label={
                                        <Typography className="text-dark">
                                            From Year<span style={{ color: "red" }}>*</span>
                                        </Typography>
                                    }

                                    {...register("fromYear", {
                                        required: "Please enter a from year  ",
                                        pattern: {
                                            value: /^\d{4}$/,
                                            message: "Please enter a valid year (YYYY)",
                                        },
                                        validate: (value) => {
                                            const year = Number(value);
                                            const currentYear = new Date().getFullYear();
                                            const toYear = watch('toYear')
                                            if (year > currentYear) {
                                                return "Future year is not allowed";
                                            }
                                            if (year < '2025') {
                                                return "Year cannot be earlier than 2025"
                                            }
                                            if (toYear && toYear > year) {
                                                return "From year has to be greater than or equal to 'To Year'"
                                            }
                                            if (year < 1900) {
                                                return "Please enter a valid year";
                                            }
                                            return true;
                                        }
                                    })}
                                    error={!!errors?.fromYear}
                                    helperText={errors?.fromYear?.message}
                                    placeholder="YYYY "
                                />
                            </Grid>
                            {/* To month */}
                            <Grid item xs={12} md={6} lg={4}>
                                <Controller
                                    control={control}
                                    name="toMonth"
                                    rules={{
                                        required: "Please select a month",
                                    }} // Validation rule
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth error={!!fieldState.error}>
                                            <InputLabel id="toMonth-label" className="text-dark">
                                                To Month <span style={{ color: "red" }}>*</span>
                                            </InputLabel>
                                            <Select
                                                {...field} // Properly bind field props
                                                labelId="toMonth-label"
                                                label={
                                                    <Typography className="text-dark">
                                                        To Month
                                                        <span style={{ color: "red" }}>*</span>
                                                    </Typography>
                                                } value={field.value || ""} // Ensure value is controlled
                                                onChange={(e) => field.onChange(e.target.value)} // Handle change correctly
                                            >
                                                <MenuItem value="">Select Month</MenuItem>
                                                {months.map((data) => (
                                                    <MenuItem key={data.id} value={data.id}>
                                                        {data.value}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {fieldState.error && (
                                                <Typography variant="body2" color="error">
                                                    {fieldState.error.message}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    )}
                                />
                            </Grid>

                            {/* To year */}
                            <Grid item xs={12} md={6} lg={4}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    label={
                                        <Typography className="text-dark">
                                            To Year<span style={{ color: "red" }}>*</span>
                                        </Typography>
                                    }

                                    {...register("toYear", {
                                        required: "Please enter a to year  ",
                                        pattern: {
                                            value: /^\d{4}$/,
                                            message: "Please enter a valid year",
                                        },
                                        validate: (value) => {
                                            const year = Number(value);
                                            const currentYear = new Date().getFullYear();
                                            const fromYear = Number(watch('fromYear'))
                                            if (year > currentYear) {
                                                return "Future year is not allowed";
                                            }
                                            if (year > fromYear) {
                                                return "To year must be greater than or equal to 'From Year'";
                                            }
                                            if (year < 1900) {
                                                return "Please enter a valid year";
                                            }
                                            return true;
                                        }
                                    })}
                                    error={!!errors?.toYear}
                                    helperText={errors?.toYear?.message}
                                    placeholder="YYYY "
                                />
                            </Grid>



                        </Grid>
                        <div className="d-flex justify-content-center mt-3">
                            <Button
                                variant="contained"
                                className="menus-color"
                                type="submit"
                            >
                                Generate
                            </Button>
                        </div>
                    </form>
                    <Modal
                        open={openForm}
                        onClose={handleFormClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style1} className="d-flex w-100 align-items-center flex-column gap-3">
                            <h4 className="alata-regular fs-3 title-font" style={{ color: "#104e29" }}>Pay chapter</h4>
                            <form className="w-100 d-flex flex-column justify-content-between h-100" onSubmit={handleSubmitPay(payChapterFn)}>
                                <Grid container rowSpacing={2} columnSpacing={3}>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Controller
                                            control={controlPay}
                                            name="chapterId"
                                            rules={{ required: "Please select a chapter" }} // Validation rule
                                            render={({ field, fieldState }) => (
                                                <Autocomplete
                                                    id="chapterId"
                                                    fullWidth
                                                    options={Chapters}
                                                    disableCloseOnSelect={false} // Ensures dropdown closes on selection
                                                    getOptionLabel={(chapter) => chapter?.title}
                                                    isOptionEqualToValue={(option, value) => option._id === value._id} // Fixes deprecation of getOptionSelected
                                                    onChange={(event, value) => {
                                                        field.onChange(value?._id); // Store single _id instead of array
                                                        clearErrorPay('amount')
                                                        setValuePay('amount', null)
                                                        if (value?._id) {
                                                            const data = {
                                                                chapterId: value?._id,
                                                                fromYear: '2025',
                                                                fromMonth: 1,
                                                                toYear: new Date().getFullYear().toString(),
                                                                toMonth: new Date().getMonth() + 1,
                                                            }
                                                            chaptermonitor(data).then(res => {
                                                                if (res?.data?.status) {
                                                                    const paymentEntries = res?.data?.data?.financialReport[res?.data?.data?.financialReport.length - 1]?.paymentEntries
                                                                    let balance;
                                                                    if (paymentEntries && paymentEntries.length > 0) {
                                                                        balance = paymentEntries[paymentEntries.length - 1]?.balance;
                                                                    }
                                                                    else {
                                                                        balance = res?.data?.data?.financialReport[res?.data?.data?.financialReport.length - 1]?.balance
                                                                    }
                                                                    setValuePay('balance', balance)
                                                                }
                                                                else {
                                                                    setValuePay('balance', '₹0')
                                                                }
                                                            })
                                                        }
                                                        else {
                                                            setValuePay('balance', null)
                                                        }
                                                    }}
                                                    value={Chapters.find((group) => group._id === field.value) || null} // Ensure it finds the correct object
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            error={!!fieldState?.error}
                                                            helperText={fieldState?.error?.message}
                                                            variant="outlined"
                                                            label={
                                                                <Typography className="text-dark w-100 d-inline-block overflow-hidden text-nowrap"
                                                                    style={{ textOverflow: "ellipsis" }}>
                                                                    Chapter Name{" "}
                                                                    <span style={{ color: "red" }}>*</span>
                                                                </Typography>
                                                            }
                                                            placeholder={watchPay('chapterId') ? '' : "Select Chapter Name"}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4} className="d-flex justify-content-start align-items-center flex-column">
                                        <div>Available Balance: <p className="text-danger">{watchPay('balance') ? watchPay('balance') : '----'}</p></div>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Controller
                                            control={controlPay}
                                            name="payType"
                                            rules={{
                                                required: "Please select a option",
                                            }} // Validation rule
                                            render={({ field, fieldState }) => (
                                                <FormControl fullWidth error={!!fieldState.error}>
                                                    <InputLabel id="toMonth-label" className="text-dark">
                                                        Credit / Debit <span style={{ color: "red" }}>*</span>
                                                    </InputLabel>
                                                    <Select
                                                        {...field} // Properly bind field props
                                                        labelId="toMonth-label"
                                                        displayEmpty
                                                        label={
                                                            <Typography className="text-dark">
                                                                Credit / Debit
                                                                <span style={{ color: "red" }}>*</span>
                                                            </Typography>
                                                        } value={field.value || ""} // Ensure value is controlled
                                                        onChange={(e) => {
                                                            field.onChange(e.target.value);
                                                            if (e.target.value.toString() === '1' && watchPay('balance') && watchPay('amount') && Number(watchPay("balance").split("₹")[1]) < Number(watchPay('amount'))) {
                                                                setErrorPay('amount', { type: 'manual', message: `Please enter an amount less than the available balance (${watchPay("balance")})` })
                                                            }
                                                            else {
                                                                clearErrorPay('amount')
                                                            }
                                                        }} // Handle change correctly
                                                    >
                                                        <MenuItem value={'0'}>Credit</MenuItem>
                                                        <MenuItem value={'1'}>Debit</MenuItem>
                                                    </Select>
                                                    {fieldState.error && (
                                                        <Typography variant="caption" className="fw-light ps-2" color="error">
                                                            {fieldState.error.message}
                                                        </Typography>
                                                    )}
                                                </FormControl>
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} lg={4}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            id="startDate"
                                            label={
                                                <Typography className="text-dark">
                                                    Payment Date <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                            }
                                            inputProps={{
                                                max: (() => {
                                                    const d = new Date();
                                                    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
                                                        d.getDate()
                                                    ).padStart(2, "0")}`;
                                                })(),
                                                min: (() => {
                                                    const d = new Date(2025, 0, 1);
                                                    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
                                                        d.getDate()
                                                    ).padStart(2, "0")}`;
                                                })(),
                                            }}
                                            variant="outlined"
                                            type="date"
                                            {...registerPay("paymentDate", {
                                                required: "Please select a date",
                                                min: { value: new Date(2025, 0, 1).toISOString().split("T")[0], message: 'Please select date after jan 01 2025' },
                                                max: { value: new Date().toISOString().split("T")[0], message: 'Please select past or present date' }
                                            })}
                                            error={!!errorsPay?.paymentDate}
                                            helperText={errorsPay?.paymentDate?.message}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <TextField
                                            fullWidth
                                            label={
                                                <Typography className="text-dark">
                                                    Amount <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                            }
                                            inputProps={{
                                                min: 0
                                            }}
                                            {...registerPay("amount", {
                                                required: 'Please enter amount to pay',
                                                pattern: {
                                                    value: /^\d+(\.\d{1,2})?$/,
                                                    message: 'Amount must be a valid number (up to 2 decimal places)'
                                                },
                                                min: { value: 1, message: 'Amount must be a postive number' },
                                                validate: (v) => {
                                                    if (watchPay('payType').toString() === '1' && watchPay("balance") && (Number(watchPay("balance").split("₹")[1]) < Number(v))) {
                                                        return `Please enter an amount less than the available balance (${watchPay("balance")})`
                                                    }
                                                    return true
                                                }
                                            })}
                                            error={!!errorsPay.amount}
                                            helperText={errorsPay?.amount?.message}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <TextField
                                            // InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            multiline
                                            rows={4}
                                            id="startDate"
                                            label={
                                                <Typography className="text-dark">
                                                    Description <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                            }
                                            variant="outlined"
                                            type="date"
                                            {...registerPay("description", {
                                                required: "Please Enter a description",
                                                validate: (v) => {
                                                    if (v.trim().length < 1) {
                                                        return 'Empty Values are not allowed'
                                                    }
                                                    return true
                                                },
                                                maxLength: { value: 150, message: 'Please enter a description less than 150 letters' }
                                            })}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end" sx={{ top: "100%" }}>
                                                        <p className="menus-green-color"> {150 - (watchPay('description') ? watchPay('description').length : 0)}/150</p>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            error={!!errorsPay?.description}
                                            helperText={errorsPay?.description?.message}
                                        />
                                    </Grid>
                                </Grid>
                                {(watchPay('payType') && watchPay('payType').toString() === '1' && (watchPay('balance') && Number(watchPay('balance').split('₹')[1]) <= 0)) && <p className="text-justify"><span className="text-danger">*</span>Payments are not allowed for this chapter as the outstanding balance is zero or less.</p>}
                                <div className="d-flex gap-3 justify-content-center mt-3 pb-3">
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        className="rounded-0"
                                        onClick={handleFormClose}
                                    >
                                        cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className="menus-color"
                                        type="submit"
                                        disabled={watchPay('payType') && watchPay('payType').toString() === '1' && watchPay('balance') && (Number(watchPay('balance').split('₹')[1]) <= 0)}
                                    >
                                        Pay
                                    </Button>
                                </div>

                            </form>

                        </Box>
                    </Modal>
                </div >}
        </>
    );
};

export default MonitorChapterShare;
